export default __webpack_public_path__ + "static/media/map-element-1-pink.49991a18.svg";